<template>
  <div class="question-list" v-loading="loading">
    <div class="show-list" v-if="radioList.length">
      <div class="topline">
        <div>一、单选</div>
      </div>
      <div class="question-box" v-for="(item, index) in radioList" :key="item.question_id">
        <div class="title">
          {{ `${index + 1}.${item.question_name}` }}
          <span>({{ item.question_value }}分)</span>
        </div>
        <div class="content">
          <div class="option" v-for="option in item.question_options" :key="option.option_label">
            <el-radio v-model="item.select" :label="option.option_label">
              {{ `${option.option_label}.${option.option_content}` }}
              <img class="option-image" :src="option.pic_url" v-if="option.pic_url" />
            </el-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="show-list" v-if="checkboxList.length">
      <div class="topline">
        <div>{{ radioList.length ? '二' : '一' }}、多选</div>
      </div>
      <div class="question-box" v-for="(item, index) in checkboxList" :key="item.question_id">
        <div class="title">
          {{ `${index + 1}.${item.question_name}` }}
          <span>({{ item.question_value }}分)</span>
        </div>
        <div class="content">
          <el-checkbox-group v-model="item.selects">
            <div class="option" v-for="option in item.question_options" :key="option.option_label">
              <el-checkbox :label="option.option_label">
                {{ `${option.option_label}.${option.option_content}` }}
                <img class="option-image" :src="option.pic_url" v-if="option.pic_url" />
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <NoData v-if="!radioList.length && !checkboxList.length"></NoData>
  </div>
</template>
<script>
import { GetExaminationPaperById } from '@/api/exam.js';
import NoData from '@/components/no-data';
export default {
  name: 'PaperPreview',
  components: {
    NoData,
  },
  props: {
    paperId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dragNoticeList: false,
      radioList: [],
      checkboxList: [],
      selectedQuestionIdList: [],
      loading: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    async init() {
      try {
        const res = await GetExaminationPaperById({ paper_id: this.paperId });
        this.questionFilter(res.paper_content);
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    questionFilter(qList) {
      for (const item of qList) {
        if (item.question_type === 1) {
          item.select = '';
          this.radioList.push(item);
        } else if (item.question_type === 2) {
          item.selects = [];
          this.checkboxList.push(item);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.question-list {
  width: 100%;
  position: relative;
  max-height: 620px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border-top: solid 1px #edeff2;
  border-bottom: solid 1px #edeff2;
  padding: 20px 0 20px 0;
  color: #313233;
  letter-spacing: 0;
  text-align: left;
  align-items: center;
  .show-list {
    width: 90%;
    display: flex;
    flex-direction: column;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    line-height: 22px;
    .topline {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .question-box {
      color: #626366;
      padding-left: 30px;
      .title {
        display: flex;
        align-items: baseline;
        padding-right: 20px;
        margin: 10px 0 8px 0;
        span {
          margin-left: 10px;
          font-size: 12px;
          line-height: 12px;
        }
      }
      .content {
        .option {
          margin: 4px 0 4px 0;
          .option-image {
            width: 300px;
            display: block;
          }
        }
      }
    }
  }
}
::v-deep.type-credit {
  margin-right: 20px;
  .el-input {
    display: inline;
  }
  .el-input__inner {
    width: 100px;
  }
}
::v-deep.credit {
  margin-top: 8px;
  .el-input {
    display: inline;
    .el-input__inner {
      width: 100px;
    }
  }
}
</style>
